let arr=[
    {name:'待定',value:'待定'},
    {name:'通过',value:'通过'},
    {name:'未通过',value:'未通过'}
]
export default arr